export enum DataCompletionOperations {
  COPY = "copy",
  AVG = "avg",
  MIN = "min",
  MAX = "max",
  VALUE = "value",
  MEDIAN = "median"
}
